// Drill registry: features register drill views by id; the shell's DrillPanel renders the
// top of the drill stack (useUi().drillStack). Open with useUi.getState().openDrill(id, params)
// from a page, or pushDrill(id, params) from inside a drill (max 3 levels).
import type { ComponentType } from 'react';

export interface DrillViewProps {
  params: Record<string, string>;
}

export interface DrillDef {
  /** Short label for the breadcrumb trail. */
  crumb: (params: Record<string, string>) => string;
  View: ComponentType<DrillViewProps>;
}

const drills = new Map<string, DrillDef>();

export function registerDrill(id: string, def: DrillDef): void {
  drills.set(id, def);
}

export function getDrill(id: string): DrillDef | undefined {
  return drills.get(id);
}

export function registeredDrills(): string[] {
  return [...drills.keys()];
}
